/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import bind from"./bind";import update from"./_update";const wrap=function(t,r){return function(){let n=update([bind(t,this)],arguments);return r.apply(this,n)}};export default wrap;